<template>
    <div class="w-full py-6 text-center text-xs">
        <!--        &copy;-->
        <!--        <a target="_blank" class="text-blue-500 hover:text-blue-800" href="https://mypallet.io">-->
        <!--            myPallet-->
        <!--        </a>-->
        <!--        {{ new Date().getFullYear() }}-->
    </div>
</template>
